import { buttonIcon } from './BsiIcon';
import { MobileTitle } from './Shared';
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';
import LinkButton from 'flarum/common/components/LinkButton';
import { AuthRequired, PageHeading, FileField, ErrorBox } from './Shared';
import { upload, t, text, record, orderUrl, errorText } from '../helpers';
export default class NewOrderPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'App--bsi';
    this.fields = {
      make: '',
      model: '',
      year: '',
      control_unit_type: '',
      control_unit_number: '',
      requested_service: '',
      comment: ''
    };
    app.setTitle(text('nav.new_order'));
  }
  view() {
    return m("div", {
      className: "BsiPage"
    }, m(MobileTitle, null), m("div", {
      className: "container"
    }, !app.session.user ? m(AuthRequired, null) : !app.forum.attribute('bsiCanCreate') ? m(ErrorBox, {
      error: t('errors.forbidden')
    }) : m("div", null, m(PageHeading, {
      icon: "plus-circle",
      title: t('nav.new_order'),
      description: t('form.description')
    }), m("form", {
      className: "BsiForm",
      onsubmit: e => this.submit(e)
    }, m(ErrorBox, {
      error: this.error
    }), m("fieldset", {
      disabled: this.loading
    }, m("legend", null, t('form.vehicle_heading')), m("div", {
      className: "BsiFormGrid"
    }, ['make', 'model', 'year', 'control_unit_type', 'control_unit_number'].map(field => this.field(field))), m("legend", null, t('form.task_heading')), this.field('requested_service', true, true), this.field('comment', true), m(FileField, {
      required: true,
      file: this.file,
      onchange: file => this.file = file,
      disabled: this.loading,
      uploading: this.loading,
      progress: this.uploadProgress
    }), m("p", {
      className: "helpText"
    }, t('form.privacy_help')), m("div", {
      className: "BsiActions"
    }, m(Button, {
      className: "Button Button--primary",
      type: "submit",
      loading: this.loading,
      icon: buttonIcon('paper-plane-tilt')
    }, t('form.submit')), m(LinkButton, {
      className: "Button",
      href: app.route('bsi.orders')
    }, t('common.cancel'))))))));
  }
  field(name, textarea, required) {
    if (textarea === void 0) {
      textarea = false;
    }
    if (required === void 0) {
      required = false;
    }
    const attrs = {
      id: 'bsi-' + name,
      name,
      className: 'FormControl',
      value: this.fields[name],
      oninput: e => this.fields[name] = e.target.value,
      placeholder: text('form.' + name + '_placeholder'),
      required,
      maxlength: textarea ? name === 'requested_service' ? 4000 : 4000 : 120
    };
    if (name === 'year') {
      attrs.type = 'number';
      attrs.min = 1950;
      attrs.max = new Date().getFullYear() + 1;
      attrs.maxlength = undefined;
    }
    return m("div", {
      className: "Form-group"
    }, m("label", {
      htmlFor: attrs.id
    }, t('form.' + name), required && m("span", {
      "aria-hidden": "true"
    }, " *")), textarea ? m("textarea", Object.assign({}, attrs, {
      rows: name === 'requested_service' ? 5 : 3
    })) : m("input", attrs));
  }
  submit(e) {
    e.preventDefault();
    if (this.loading) return;
    if (!this.file || !this.fields.requested_service.trim()) {
      this.error = t('form.required_error');
      return;
    }
    this.loading = true;
    this.error = null;
    this.uploadProgress = 0;
    const body = new FormData();
    for (const [key, value] of Object.entries(this.fields)) if (value.trim()) body.append(key, value.trim());
    body.append('file', this.file);
    upload('/orders', {
      body,
      onProgress: percent => this.uploadProgress = percent
    }).then(response => m.route.set(orderUrl(record(response.data).id))).catch(error => {
      this.error = errorText(error);
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('bsi-orders', 'forum/components/NewOrderPage', NewOrderPage);